// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"ab5c5a8d","198":"e9204f6d","200":"e9204f6d","366":"e9204f6d","536":"857fe081","744":"e9204f6d"}[chunkId] + ".css";
};